import React, { useState } from "react";
import { Tabs, Alert, Space } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import CreateDemoSchoolView from "./CreateDemoSchoolView";
import AddDemoUserView from "./AddDemoUserView";
import DemoSchoolsListView from "./DemoSchoolsListView";
import CredentialsModal from "./CredentialsModal";

type CredentialsType = {
  email: string;
  password: string;
  schoolName: string;
  classroomsCreated: number;
};

const DemoProvision: React.FC = () => {
  const [refreshToken, setRefreshToken] = useState(0);
  const [credentials, setCredentials] = useState<CredentialsType | null>(null);

  const handleCreated = (creds: CredentialsType) => {
    setCredentials(creds);
    setRefreshToken((t) => t + 1);
  };

  const handleCloseCredentials = () => {
    setCredentials(null);
  };

  const handleDeleted = () => {
    setRefreshToken((t) => t + 1);
  };

  const tabItems = [
    {
      key: "crear",
      label: "Crear escuela demo",
      children: <CreateDemoSchoolView onCreated={handleCreated} />,
    },
    {
      key: "agregar-usuario",
      label: "Agregar usuario demo",
      children: (
        <AddDemoUserView
          onProvisioned={handleCreated}
          refreshToken={refreshToken}
        />
      ),
    },
    {
      key: "lista",
      label: "Escuelas demo",
      children: (
        <DemoSchoolsListView
          refreshToken={refreshToken}
          onDeleted={handleDeleted}
        />
      ),
    },
  ];

  return (
    <Space direction="vertical" style={{ width: "100%" }} size="middle">
      <Alert
        type="info"
        showIcon
        icon={<InfoCircleOutlined />}
        message="Las escuelas demo se administran también desde la sección Escuelas"
        description="Desde el panel de Escuelas podés cambiar programas, agregar o editar usuarios, modificar classrooms y demás. Esta pantalla es solo para el alta rápida de escuelas demo y la provisión de usuarios demo adicionales."
      />
      <Tabs
        defaultActiveKey="crear"
        destroyInactiveTabPane={false}
        items={tabItems}
      />
      <CredentialsModal
        open={credentials !== null}
        credentials={credentials}
        onClose={handleCloseCredentials}
      />
    </Space>
  );
};

export default DemoProvision;
